module.exports = __webpack_public_path__ + "static/media/prostate.6d8d3901.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/prostate.jpg
 ** module id = 572
 ** module chunks = 0
 **/